<template>
  <div class="home">
    <div class="ldr-text">
      <div>
        <img src="/images/svg/loader.svg" class="img-fluid" alt="" />
<!--        <img src="/video/goLoader1.gif" class="img-fluid" alt="" />-->
        <h1>
          {{ _T('Sorry we could not access our web server') }}..
          {{
            _T(`Please relaod
          page in 5 mins`)
          }}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OfflinePage',
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.home {
  background: $font-color;
  height: $px600;
  .ldr-text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
    > div {
      margin-top: -60px;
    }
    img,
    svg {
      width: calc(20% + (60 - 20) * ((100vw - 320px) / (1920 - 320)));
      margin-bottom: calc(20px + (50 - 20) * ((100vw - 320px) / (1920 - 320)));
      animation: carbody 1s linear infinite;
    }
    @keyframes carbody {
      0% {
        transform: translateY(3px);
      }
      60% {
        transform: translateY(5px);
      }
      80% {
        transform: translateY(4px);
      }
    }
    h1 {
      font-size: calc(20px + (36 - 20) * ((100vw - 320px) / (1920 - 320)));
      line-height: calc(20px + (44 - 20) * ((100vw - 320px) / (1920 - 320)));
      color: #ffffff;
      font-weight: normal;
      margin-bottom: 0;
      text-transform: capitalize;
    }
  }
}
</style>
